/* BC email popup: triggers, frequency capping, focus trap, copy-code.
   Email capture is a native {% form 'customer' %}, so a successful submit reloads
   the page; we reopen the popup in its success state and suppress it thereafter. */
(function () {
  var root = document.querySelector('[data-bc-popup]');
  if (!root) return;

  var DONE = 'bc_popup_done';       // subscribed: never show again
  var SNOOZE = 'bc_popup_snooze';   // dismissed: hide until timestamp
  var SUBMIT = 'bc_popup_submitting'; // set on our submit, read after reload

  var dialog = root.querySelector('.bc-popup__dialog');
  var isSuccess = !!root.querySelector('[data-bc-success]');
  var trigger = root.getAttribute('data-trigger') || 'exit_delay';
  var delayMs = (parseInt(root.getAttribute('data-delay'), 10) || 20) * 1000;
  var cooldownDays = parseInt(root.getAttribute('data-cooldown'), 10) || 30;
  var lastFocused = null;

  function ls(get, key, val) {
    try { return get ? localStorage.getItem(key) : localStorage.setItem(key, val); }
    catch (e) { return null; }
  }
  function rm(key) { try { localStorage.removeItem(key); } catch (e) {} }

  function focusables() {
    return Array.prototype.filter.call(
      root.querySelectorAll('a[href],button,input,textarea,[tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null && !el.disabled; }
    );
  }
  function onKey(e) {
    if (e.key === 'Escape') { close(true); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function open() {
    lastFocused = document.activeElement;
    root.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var target = root.querySelector('input[type=email]') || root.querySelector('button, a[href]') || dialog;
    if (target && target.focus) target.focus();
    document.addEventListener('keydown', onKey);
  }
  function close(snooze) {
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    if (snooze) ls(false, SNOOZE, String(Date.now() + cooldownDays * 86400000));
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  // Close handlers (backdrop, X, decline)
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-bc-close]')) close(true);
  });
  // Copy code
  var copyBtn = root.querySelector('[data-bc-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = copyBtn.getAttribute('data-code') || '';
      var done = function () { var t = copyBtn.textContent; copyBtn.textContent = 'Copied'; setTimeout(function(){ copyBtn.textContent = t; }, 1600); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
      else done();
    });
  }
  // Flag our own submission so the reload can distinguish it from other customer forms
  var form = root.querySelector('form');
  if (form) form.addEventListener('submit', function () { ls(false, SUBMIT, '1'); });

  // Success reload: subscribed. Suppress permanently; reopen only if it was our form.
  if (isSuccess) {
    var wasOurs = ls(true, SUBMIT) === '1';
    rm(SUBMIT);
    ls(false, DONE, '1');
    if (wasOurs) open();
    return;
  }

  // Suppression checks
  if (ls(true, DONE) === '1') return;
  var snoozeTs = parseInt(ls(true, SNOOZE) || '0', 10);
  if (snoozeTs && snoozeTs > Date.now()) return;

  // Arm triggers
  var fired = false, timer = null;
  function fire() { if (fired) return; fired = true; cleanup(); open(); }
  function cleanup() { if (timer) clearTimeout(timer); document.removeEventListener('mouseout', onExit); }
  function onExit(e) { if (e.clientY <= 0 && !e.relatedTarget) fire(); }

  var isDesktop = window.matchMedia('(min-width: 750px)').matches;
  if (trigger === 'delay' || !isDesktop) {
    timer = setTimeout(fire, delayMs);
  } else if (trigger === 'exit_delay') {
    document.addEventListener('mouseout', onExit);
    timer = setTimeout(fire, Math.max(delayMs, 45000)); // fallback so desktop visitors who never exit still see it
  } else if (trigger === 'exit') {
    document.addEventListener('mouseout', onExit);
  }
})();
